import { Injectable } from '@angular/core';
import { Settings } from './app.settings.model';
import { HttpClient } from '@angular/common/http';
import { AuthService } from './shared/services/auth.service';
import { UtilsUmsService } from './shared/services/utils.ums.service';

@Injectable()
export class AppSettings {
    public settings = new Settings(
        'AdminPortal',   //theme name
        true,       //loadingSpinner
        true,       //fixedHeader
        true,       //sidenavIsOpened
        true,       //sidenavIsPinned  
        true,       //sidenavUserBlock 
        'vertical', //horizontal , vertical
        'default',  //default, compact, mini
        UtilsUmsService.getTheme(),   //indigo-light, teal-light, red-light, blue-dark, green-dark, pink-dark
        false       // true = rtl, false = ltr
    );

    constructor(private http: HttpClient) {
        if (AuthService.isLoggedIn && AuthService.getUser().settings != null) {
            console.log('loggedin > ' + JSON.stringify(AuthService.getUser()));
            this.settings = AuthService.getUser().settings;
        } else {
            console.log('loggedout');
        }
    }
}

